import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function CookiePolicy() {
  return (
    <LegalPage
      ns="cookies"
      sectionKeys={["s1", "s2", "s3", "s4", "s5", "s6"]}
    />
  );
}
